export default __webpack_public_path__ + "static/media/Chat-Numbers-System-18.afc7fdb3.svg";